export const persistAuth = 'persist:auth';
